var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _rect, _path57, _circle, _rect2, _path58, _circle2, _rect3, _path59, _circle3, _rect4, _path60, _path61, _path62, _path63, _path64, _circle4, _path65, _path66, _path67, _circle5, _path68, _path69, _path70, _circle6, _path71, _path72, _path73;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtaImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 850.53801,
    height: 740.82953,
    viewBox: "0 0 850.53801 740.82953",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M941.609,737.32827l-1.04.41a307.07836,307.07836,0,0,1-175.66,55.31h-1.52a309.42737,309.42737,0,0,1-64.7-6.79c-90.68-19.41-157.97-86.9-177.29-177.58a305.9854,305.9854,0,0,1-7.33-66.69v-1.55a308.96083,308.96083,0,0,1,56.15-177.24l.52-1.09,87.17,40.92,19.07,8.95,4.33,2.03.4.16.18.09,38.95,18.29.71.34,2.01.94.22.1,16.97,7.97.96.45,9.27,4.35,5.88,2.76,1.48.7,32.86,15.43,13.06,6.14,2.98,1.39,30.85,14.5,6.24,2.93.54.26c63.81,29.93,112.88,79.11,143.53,142.24l.07-.02.41,1.03C961.87,648.39828,961.169,698.04828,941.609,737.32827Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M556.57711,321.30102a324.69726,324.69726,0,0,0-27.152,129.19289v1.63785a322.4747,322.4747,0,0,0,7.71633,70.15521c20.33725,95.41716,91.51409,166.79082,186.93149,187.0379a325.43036,325.43036,0,0,0,68.0433,7.1469h1.59844a323.13114,323.13114,0,0,0,184.78459-58.202c20.58664-14.66237,38.93911-31.80017,54.5053-51.2652q2.5341-3.17983,4.95455-6.42322l-289.7493-136.11877Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M650.12236,701.63485a15.88384,15.88384,0,0,1-11.15719,15.13676,15.67332,15.67332,0,0,1-3.97955.50458,15.884,15.884,0,0,1-15.641-15.641c.00263-9.72913,16.73169-23.55829,19.00824-25.49265a.75983.75983,0,0,1,.97328,0C641.61329,678.07656,650.12236,691.90572,650.12236,701.63485Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#6366f1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M644.64085,701.63485a10.40355,10.40355,0,0,1-7.31127,9.92273,10.27341,10.27341,0,0,1-2.60882.33064,10.40437,10.40437,0,0,1-10.24437-10.55337c.00172-6.37759,10.96587-15.44372,12.45387-16.702a.49774.49774,0,0,1,.638,0C639.15086,686.19112,644.64085,695.25726,644.64085,701.63485Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M780.52231,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-462.58a1.7,1.7,0,0,1,3.4,0v462.58A1.69788,1.69788,0,0,1,780.52231,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M780.52231,400.31045a1.694,1.694,0,0,1-1.7-1.7v-36.38a1.7,1.7,0,0,1,3.4,0v36.38A1.694,1.694,0,0,1,780.52231,400.31045Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M780.52231,455.03046a1.694,1.694,0,0,1-1.7-1.7v-21.46a1.7,1.7,0,1,1,3.4,0v21.46A1.694,1.694,0,0,1,780.52231,455.03046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M650.17233,337.75047a1.69787,1.69787,0,0,1-1.7-1.7v-28.06a1.7,1.7,0,1,1,3.4,0v28.06A1.69787,1.69787,0,0,1,650.17233,337.75047Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M650.17233,400.31045a1.69788,1.69788,0,0,1-1.7-1.7V338.69046a1.7,1.7,0,0,1,3.4,0v59.92A1.69787,1.69787,0,0,1,650.17233,400.31045Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M660.65747,387.86982a1.69787,1.69787,0,0,1-1.7-1.7v-24.92a1.7,1.7,0,0,1,3.4,0v24.92A1.69787,1.69787,0,0,1,660.65747,387.86982Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M689.31735,400.31045a1.69787,1.69787,0,0,1-1.7-1.7V311.05048a1.7,1.7,0,1,1,3.4,0v87.56A1.69787,1.69787,0,0,1,689.31735,400.31045Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M689.31735,297.67046a1.69787,1.69787,0,0,1-1.7-1.7V289.37a1.7,1.7,0,1,1,3.4,0v6.6A1.69787,1.69787,0,0,1,689.31735,297.67046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M677.31213,328.19045a1.69787,1.69787,0,0,1-1.7-1.7V289.37a1.7,1.7,0,1,1,3.4,0v37.12A1.69786,1.69786,0,0,1,677.31213,328.19045Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M668.29238,299.91046a1.69787,1.69787,0,0,1-1.7-1.7v-8.84a1.7,1.7,0,1,1,3.4,0v8.84A1.69787,1.69787,0,0,1,668.29238,299.91046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M625.58227,400.31045a1.69787,1.69787,0,0,1-1.7-1.7V321.54047a1.7,1.7,0,0,1,3.4,0v77.07A1.69787,1.69787,0,0,1,625.58227,400.31045Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M625.58227,309.87048a1.69787,1.69787,0,0,1-1.7-1.7v-18.5a1.7,1.7,0,1,1,3.4,0v18.5A1.69787,1.69787,0,0,1,625.58227,309.87048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M690.42748,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-79.05a1.7,1.7,0,0,1,3.4,0v79.05A1.69786,1.69786,0,0,1,690.42748,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M690.42748,669.89046a1.69787,1.69787,0,0,1-1.7-1.7V490.44047a1.7,1.7,0,0,1,3.4,0V668.19046A1.69786,1.69786,0,0,1,690.42748,669.89046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M690.42748,474.2905a1.69787,1.69787,0,0,1-1.7-1.7V415.30048a1.7,1.7,0,0,1,3.4,0v57.29A1.69788,1.69788,0,0,1,690.42748,474.2905Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M690.42748,401.77047a1.69787,1.69787,0,0,1-1.7-1.7V383.55048a1.7,1.7,0,1,1,3.4,0v16.52A1.69788,1.69788,0,0,1,690.42748,401.77047Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M627.80226,764.27046a1.69786,1.69786,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,627.80226,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M627.80226,741.4805a1.69787,1.69787,0,0,1-1.7-1.7v-42.44a1.7,1.7,0,0,1,3.4,0v42.44A1.69788,1.69788,0,0,1,627.80226,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M627.80226,654.60048a1.69787,1.69787,0,0,1-1.7-1.7V543.45047a1.7,1.7,0,0,1,3.4,0V652.90048A1.69787,1.69787,0,0,1,627.80226,654.60048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M627.80226,529.43048a1.69787,1.69787,0,0,1-1.7-1.7V499.76048a1.7,1.7,0,0,1,3.4,0v27.97A1.69787,1.69787,0,0,1,627.80226,529.43048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M627.80226,486.20048a1.69787,1.69787,0,0,1-1.7-1.7V414.07048a1.7,1.7,0,0,1,3.4,0v70.43A1.69787,1.69787,0,0,1,627.80226,486.20048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M651.32747,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,651.32747,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M651.32747,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V484.50048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,651.32747,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M651.32747,472.11049a1.69787,1.69787,0,0,1-1.7-1.7V437.60048a1.7,1.7,0,0,1,3.4,0v32.81A1.69787,1.69787,0,0,1,651.32747,472.11049Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M651.32747,423.69046a1.69787,1.69787,0,0,1-1.7-1.7V407.87a1.7,1.7,0,1,1,3.4,0v14.12A1.69786,1.69786,0,0,1,651.32747,423.69046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M663.67744,461.89046a1.69787,1.69787,0,0,1-1.7-1.7V433.57048a1.7,1.7,0,0,1,3.4,0v26.62A1.69786,1.69786,0,0,1,663.67744,461.89046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M663.67744,419.57048a1.69787,1.69787,0,0,1-1.7-1.7V404.85048a1.7,1.7,0,0,1,3.4,0v13.02A1.69787,1.69787,0,0,1,663.67744,419.57048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M663.67744,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-222.82a1.7,1.7,0,0,1,3.4,0v222.82A1.69787,1.69787,0,0,1,663.67744,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M663.67744,525.21048a1.69787,1.69787,0,0,1-1.7-1.7V475.88048a1.7,1.7,0,1,1,3.4,0v47.63A1.69787,1.69787,0,0,1,663.67744,525.21048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M676.91743,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,676.91743,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M676.91743,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V463.41048a1.7,1.7,0,1,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,676.91743,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M676.91743,449.39046a1.69786,1.69786,0,0,1-1.7-1.7V423.81046a1.7,1.7,0,1,1,3.4,0v23.88A1.69786,1.69786,0,0,1,676.91743,449.39046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M676.91743,408.12048a1.69787,1.69787,0,0,1-1.7-1.7v-4.75a1.7,1.7,0,1,1,3.4,0v4.75A1.69787,1.69787,0,0,1,676.91743,408.12048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M602.2724,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,602.2724,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M602.2724,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V473.43048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,602.2724,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M602.2724,459.41048a1.69787,1.69787,0,0,1-1.7-1.7V405.50048a1.7,1.7,0,0,1,3.4,0v52.21A1.69788,1.69788,0,0,1,602.2724,459.41048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M715.11231,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,715.11231,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M715.11231,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V552.41048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,715.11231,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M715.11231,535.58047a1.69787,1.69787,0,0,1-1.7-1.7V496.26048a1.7,1.7,0,1,1,3.4,0v37.62A1.69788,1.69788,0,0,1,715.11231,535.58047Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M715.11231,484.59046a1.69786,1.69786,0,0,1-1.7-1.7V465.53046a1.7,1.7,0,0,1,3.4,0v17.36A1.69787,1.69787,0,0,1,715.11231,484.59046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M715.11231,453.32048a1.69787,1.69787,0,0,1-1.7-1.7V403.64046a1.7,1.7,0,1,1,3.4,0v47.98A1.69787,1.69787,0,0,1,715.11231,453.32048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M741.57233,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,741.57233,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M741.57233,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V552.41048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,741.57233,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M741.57233,535.58047a1.69787,1.69787,0,0,1-1.7-1.7V488.0305a1.7,1.7,0,1,1,3.4,0v45.85A1.69788,1.69788,0,0,1,741.57233,535.58047Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M741.57233,474.06048a1.69787,1.69787,0,0,1-1.7-1.7v-7.94a1.7,1.7,0,0,1,3.4,0v7.94A1.69787,1.69787,0,0,1,741.57233,474.06048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M741.57233,452.23048a1.69787,1.69787,0,0,1-1.7-1.7V425.81046a1.7,1.7,0,0,1,3.4,0v24.72A1.69786,1.69786,0,0,1,741.57233,452.23048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M741.57233,411.88048a1.69787,1.69787,0,0,1-1.7-1.7v-9.63a1.7,1.7,0,1,1,3.4,0v9.63A1.69787,1.69787,0,0,1,741.57233,411.88048Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M759.20743,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,759.20743,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M759.20743,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V413.05048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,759.20743,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M776.84231,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,776.84231,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M776.84231,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V413.05048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,776.84231,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M637.39738,764.27046a1.69787,1.69787,0,0,1-1.7-1.7v-7.39a1.7,1.7,0,0,1,3.4,0v7.39A1.69787,1.69787,0,0,1,637.39738,764.27046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M637.39738,741.4805a1.69787,1.69787,0,0,1-1.7-1.7V474.80048a1.7,1.7,0,0,1,3.4,0V739.7805A1.69788,1.69788,0,0,1,637.39738,741.4805Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M637.39738,461.89046a1.69787,1.69787,0,0,1-1.7-1.7V414.32048a1.7,1.7,0,0,1,3.4,0v45.87A1.69787,1.69787,0,0,1,637.39738,461.89046Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 738.8273,
    width: 849.0574,
    height: 2,
    fill: "#3f3d56"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M924.53,819.39191s.62171-13.02673,13.36639-11.51257",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 745.3343,
    cy: 723.076,
    r: 6.37865,
    fill: "#6366f1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 744.08477,
    y: 733.72085,
    width: 1.80054,
    height: 12.60376,
    fill: "#3f3d56"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M698.53,819.39191s.62171-13.02673,13.36639-11.51257",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 519.3343,
    cy: 723.076,
    r: 6.37865,
    fill: "#6366f1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 518.08477,
    y: 733.72085,
    width: 1.80054,
    height: 12.60376,
    fill: "#3f3d56"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.53,819.39191s.62171-13.02673,13.36639-11.51257",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 829.3343,
    cy: 723.076,
    r: 6.37865,
    fill: "#6366f1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 828.08477,
    y: 733.72085,
    width: 1.80054,
    height: 12.60376,
    fill: "#3f3d56"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M253.15128,759.95384a1.1865,1.1865,0,0,0,1.19,1.19h498.29a1.19,1.19,0,0,0,0-2.38h-498.29A1.1865,1.1865,0,0,0,253.15128,759.95384Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#3f3d56"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M460.25655,662.55725c10.90352,5.12868,22.24892,8.01721,33.28866,4.07216,11.04-3.94506,17.86786-16.88647,13.196-27.57962a19.16016,19.16016,0,0,1-28.4503,15.21109c-7.92111-4.773-11.73835-14.94725-10.00256-24.10382s9.2702-16.87935,17.2958-21.63511,17.41641-7.21689,26.58891-9.07443a127.02076,127.02076,0,0,1,114.53264,41.51339",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#e6e6e6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M537.15128,488.95384a1.1865,1.1865,0,0,0,1.19,1.19h125.88a1.19,1.19,0,0,0,0-2.38h-125.88A1.1865,1.1865,0,0,0,537.15128,488.95384Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M499.15128,514.95384a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,499.15128,514.95384Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M499.15128,540.95384a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,499.15128,540.95384Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 371.7837,
    cy: 97.31648,
    r: 9.31648,
    fill: "#6366f1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M547.79367,173.0429a1.1865,1.1865,0,0,0,1.19,1.19h125.88a1.19,1.19,0,0,0,0-2.38h-125.88A1.1865,1.1865,0,0,0,547.79367,173.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M509.79367,199.0429a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,509.79367,199.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M509.79367,225.0429a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,509.79367,225.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 382.42609,
    cy: 412.31648,
    r: 9.31648,
    fill: "#6366f1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M558.43606,488.0429a1.1865,1.1865,0,0,0,1.19,1.19h125.88a1.19,1.19,0,0,0,0-2.38h-125.88A1.1865,1.1865,0,0,0,558.43606,488.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M520.43606,514.0429a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,520.43606,514.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M520.43606,540.0429a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,520.43606,540.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.77391,
    cy: 295.31648,
    r: 9.31648,
    fill: "#6366f1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M365.78389,371.0429a1.1865,1.1865,0,0,0,1.19,1.19h125.88a1.19,1.19,0,0,0,0-2.38h-125.88A1.1865,1.1865,0,0,0,365.78389,371.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M327.78389,397.0429a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,327.78389,397.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M327.78389,423.0429a1.1865,1.1865,0,0,0,1.19,1.19h201.88a1.19,1.19,0,0,0,0-2.38h-201.88A1.1865,1.1865,0,0,0,327.78389,423.0429Z",
    transform: "translate(-174.73099 -79.58524)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaImage);
export default __webpack_public_path__ + "static/media/cta-image.acea0d05a6823a322f9d883c45def909.svg";
export { ForwardRef as ReactComponent };